function safeSlice(value: unknown, start: number, end?: number): string {
  if (typeof value === 'string') {
    return value.slice(start, end);
  }
  return String(value).slice(start, end);
}

export { safeSlice };

export const slugToMerchantId = (slug: string) => {
  return `${slug}.myshopify.com`;
};

export const downloadFile = (data: any, filename: string) => {
  const jsonString = JSON.stringify(data, null, 2);
  const blob = new Blob([jsonString], { type: 'application/json' });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};

export const ensurePrefixedUrl = (url: string | null | undefined) => {
  if (!url) {
    return '';
  }
  const parsedUrl = new URL(url);
  if (!parsedUrl.hostname.startsWith('www.')) {
    parsedUrl.hostname = `www.${parsedUrl.hostname}`;
  }
  return parsedUrl.toString();
};

export async function getFavicon(url: string): Promise<string | null> {
  try {
    const defaultFavicon = new URL('/favicon.ico', url).href;

    // Check if the default favicon exists
    const defaultResponse = await fetch(defaultFavicon);
    if (defaultResponse.ok) {
      return defaultFavicon; // Return default favicon if available
    }

    // If not, fetch the website HTML to find the favicon link
    const response = await fetch(url);
    const html = await response.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    // Find the favicon from <link> tags
    const faviconTag =
      doc.querySelector("link[rel~='icon']") ?? doc.querySelector("link[rel='shortcut icon']");

    if (faviconTag) {
      const faviconUrl = new URL(faviconTag.getAttribute('href') ?? '', url).href;
      return faviconUrl;
    }

    // If no favicon found, return null
    return null;
  } catch (error) {
    console.error('Error fetching favicon:', error);
    return null;
  }
}

export const urlToFile = async (url: string, filename: string) => {
  const response = await fetch(url);
  const blob = await response.blob();
  return new File([blob], filename, { type: blob.type });
};

export const toSnakeCase = (str: string) =>
  str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);
